import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations, LANGUAGES } from "./translations";

const I18nContext = createContext({
  lang: "nl",
  setLang: () => {},
  t: (k) => k,
});

function get(obj, path) {
  return path.split(".").reduce((o, k) => (o ? o[k] : undefined), obj);
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = localStorage.getItem("tr_lang");
      if (saved && translations[saved]) return saved;
    } catch {}
    return "nl";
  });

  const setLang = useCallback((l) => {
    if (!translations[l]) return;
    setLangState(l);
    try {
      localStorage.setItem("tr_lang", l);
    } catch {}
    document.documentElement.lang = l;
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key, vars) => {
      let val = get(translations[lang], key);
      if (val == null) val = get(translations.nl, key);
      if (val == null) return key;
      if (vars && typeof val === "string") {
        Object.entries(vars).forEach(([k, v]) => {
          val = val.replace(new RegExp(`\\{${k}\\}`, "g"), v);
        });
      }
      return val;
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
